import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const cardVariants = {
  hidden: { opacity: 0, y: -60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const TechStackCard = ({ badge, heading, image, imageWidth, imageHeight, imageAlign = 'left', imageScale = 1, imageOffsetY = 0 }) => {
  const imageWrapRef = useRef(null);
  const isImageInView = useInView(imageWrapRef, { once: true, amount: 0.3 });

  return (
    <motion.div
      variants={cardVariants}
      className="relative flex flex-col items-start gap-2 w-[282px] h-[360px] shrink-0 bg-[#181B43] rounded-[20px] p-4 overflow-hidden"
    >
      <span className="relative z-10 inline-flex items-center bg-[#D1FAE5] border border-[#10B981] text-[#064E3B] text-[12px] leading-4 tracking-[0.01em] font-[Gilroy-Regular] rounded-lg px-3 py-2">
        {badge}
      </span>
      <span className="relative z-10 text-[#F8FAFC] font-gilroy-bold text-[20px] leading-[28px] tracking-[0.02em]">
        {heading}
      </span>
      {image && (
        <div
          ref={imageWrapRef}
          className={`absolute bottom-0 ${imageAlign === 'right' ? 'right-0' : 'left-0'}`}
          style={{
            width: `${imageScale * 100}%`,
            aspectRatio: `${imageWidth} / ${imageHeight}`,
            transform: imageOffsetY ? `translateY(${imageOffsetY}px)` : undefined,
          }}
        >
          {isImageInView && (
            <img src={image} alt={heading} loading="lazy" className="w-full h-full object-contain" />
          )}
        </div>
      )}
    </motion.div>
  );
};

export default TechStackCard;
